/**
 * Custom storage adapter for Supabase that's safe to use during server-side rendering
 */

import AsyncStorage from '@react-native-async-storage/async-storage';
import logger from './logger';

// Check if we're in a browser/React Native environment
const isBrowser = () => typeof window !== 'undefined';

// Create a storage adapter that's safe during server-side rendering
const customStorageAdapter = {
  getItem: async (key) => {
    try {
      if (!isBrowser()) return null;
      return await AsyncStorage.getItem(key);
    } catch (error) {
      logger.warn('Error getting item from storage:', error);
      return null;
    }
  },
  setItem: async (key, value) => {
    try {
      if (!isBrowser()) return;
      await AsyncStorage.setItem(key, value);
    } catch (error) {
      logger.warn('Error setting item in storage:', error);
    }
  },
  removeItem: async (key) => {
    try {
      if (!isBrowser()) return;
      await AsyncStorage.removeItem(key);
    } catch (error) {
      logger.warn('Error removing item from storage:', error);
    }
  },
};

export default customStorageAdapter;
